import React from 'react';
import { Form } from 'react-bootstrap';

import { useFormikContext } from 'formik';

export const CheckoutServiceRestrictions = ({ data }) => {
  const { values, handleChange, errors, touched } = useFormikContext();
  if (data.length === 0) {
    return 'There is no service restrictions.';
  }
  return (
    <>
      <p className="fw-bold">Service Restrictions</p>
      {data.map((item) => (
        <p key={item}>* {item}</p>
      ))}
      <Form.Check
        type="checkbox"
        name="serviceRestrictions"
        size="sm"
        onChange={handleChange}
        value={values.serviceRestrictions}
        className="mb-2"
        isValid={touched.serviceRestrictions && !errors.serviceRestrictions}
        isInvalid={touched.serviceRestrictions && errors.serviceRestrictions}
        label={<> I have read and understood the service restrictions.</>}
        feedback={errors.serviceRestrictions}
        feedbackType="invalid"
      />
    </>
  );
};
